import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import apiAdonis from '../../../Services/adonis';

import { IconeHeaderSideBar } from '../../../Assets';
import * as Component from './style';
import { Controller } from '../../Menu'
import { SignIn as ContextSignIn } from '../../../Context';
import { NotificacaoInterna } from '../../../Services/Notification';
import { Button, FormGroup, Icon, MenuItem, Checkbox, Collapse, Divider } from '@blueprintjs/core';
import Lottie from 'react-lottie';
import * as LottieFiles from '../../../Data/Lottie/index'

const View: React.FC = () => {
    /* #region  Variáveis  */
    const History = useHistory();
    const [getExibirSideBar, setExibirSideBar] = useState<boolean>(false);
    const [empPermissions, setEmpPermissions] = useState<{ cd_emp: number }[]>();
    const [getAnalyticsClicked, setAnalyticsClicked] = useState<boolean>(false);
    /* #endregion */

    /* #region  Funções  */

    function ValidarAcesso(emp: Array<number>): boolean {
        if (!empPermissions || !(empPermissions?.length > 0)) { return false }
        if (emp.find(Item => empPermissions?.find(emp_perm => emp_perm.cd_emp === Item))) {
            return true
        }
        else {
            return false
        }
    };
    function AcessarPaginaAnalytics(path: string): void {
        History.push(`/Menu/Analytics/${path}`);
        window.location.reload();
    };
    useEffect(() => {
        async function componentDidMount() {
            await apiAdonis.get("/empPerms", {
                params: { userId: JSON.parse(localStorage.getItem("user") ?? "{}").id }
            }).then(res => setEmpPermissions(res.data))
        }
        componentDidMount();
    }, []);
    return (
        <Fragment>
            <Component.Header style={getExibirSideBar == true ? { marginLeft: "30px", transition: "margin-left 1s" } : { marginLeft: "30px", transition: "margin-left 1s" }}>
                <img style={{ width: "15px", height: "15px", cursor: "pointer" }} src={IconeHeaderSideBar} alt=""
                    onClick={async () => { await setExibirSideBar(getExibirSideBar == false); }} />
            </Component.Header>
            <Component.Container style={getExibirSideBar == true ? { marginLeft: "0", transition: "margin-left 1s" } : { marginLeft: "-250px", transition: "margin-left 1s" }}>
                <Component.HeaderContent>
                    {/* Para Tudo e Botão Abrir/Fechar */}
                    <div style={getExibirSideBar == true ? { width: "250px", height: "100%", display: 'flex', flexDirection: 'column', alignItems: 'center', padding: "40px 0", overflow: "auto" } : { width: "250px", height: "100%", display: 'flex', flexDirection: 'column', alignItems: 'center', padding: "40px 0" }}>
                        {/* Analytics */}
                        <div style={{ width: "100%" }}>
                            <div className="element" style={{ height: "70px", padding: "0 35px" }} onClick={() => getAnalyticsClicked ? setAnalyticsClicked(false) : setAnalyticsClicked(true)}>
                                <Icon icon="chart" />
                                <div style={{ width: "70%", height: "40px", display: "flex", alignItems: "center", marginLeft: "1vw" }}>Analytics</div>
                                <Lottie
                                    options={{
                                        loop: true,
                                        autoplay: true,
                                        animationData: LottieFiles.SwipeWhite,
                                        rendererSettings: {
                                            preserveAspectRatio: "xMidYMid slice"
                                        }
                                    }}
                                    height={30}
                                    width={30}
                                    style={getAnalyticsClicked ? { transform: `rotate(180deg)`, transition: "transform 0.5s" } : { transform: `rotate(0deg)`, transition: "transform 0.5s" }} />
                            </div>
                            <Collapse isOpen={getAnalyticsClicked}>
                                {ValidarAcesso([1]) && <div onClick={() => { AcessarPaginaAnalytics("Mapas") }} className="element" style={{ height: "40px", fontSize: "13px", borderBottom: "1px solid #1E485D" }}>
                                    <Icon icon="map-marker" iconSize={10} />
                                    <div style={{ width: "60%", height: "40px", display: "flex", alignItems: "center", marginLeft: "1vw" }}>Mapas</div>
                                </div>}
                                {ValidarAcesso([25, 4]) && <div onClick={() => { AcessarPaginaAnalytics("Distratos") }} className="element" style={{ height: "40px", fontSize: "13px", borderBottom: "1px solid #1E485D" }}>
                                    <Icon icon="remove-column" iconSize={10} />
                                    <div style={{ width: "60%", height: "40px", display: "flex", alignItems: "center", marginLeft: "1vw" }}>Distratos</div>
                                </div>}
                                {ValidarAcesso([25, 4]) && <div onClick={() => { AcessarPaginaAnalytics("VendaNoTempo") }} className="element" style={{ height: "40px", fontSize: "13px", borderBottom: "1px solid #1E485D" }}>
                                    <Icon icon="stopwatch" iconSize={10} />
                                    <div style={{ width: "60%", height: "40px", display: "flex", alignItems: "center", marginLeft: "1vw" }}>Gestão de Receita</div>
                                </div>}
                                {ValidarAcesso([20, 1]) && <div onClick={() => { AcessarPaginaAnalytics("Fluxo") }} className="element" style={{ height: "40px", fontSize: "13px", borderBottom: "1px solid #1E485D" }}>
                                    <Icon icon="series-search" iconSize={10} />
                                    <div style={{ width: "60%", height: "40px", display: "flex", alignItems: "center", marginLeft: "1vw" }}>Fluxo</div>
                                </div>}
                                {ValidarAcesso([4]) && <div onClick={() => { AcessarPaginaAnalytics("Desembolso") }} className="element" style={{ height: "40px", fontSize: "13px", borderBottom: "1px solid #1E485D" }}>
                                    <Icon icon="alignment-bottom" iconSize={10} />
                                    <div style={{ width: "60%", height: "40px", display: "flex", alignItems: "center", marginLeft: "1vw" }}>Relatório 260</div>
                                </div>}
                                {ValidarAcesso([1]) && <div onClick={() => { AcessarPaginaAnalytics("Carteira") }} className="element" style={{ height: "40px", fontSize: "13px", borderBottom: "1px solid #1E485D" }}>
                                    <Icon icon="grouped-bar-chart" iconSize={10} />
                                    <div style={{ width: "60%", height: "40px", display: "flex", alignItems: "center", marginLeft: "1vw" }}>Carteira</div>
                                </div>}
                                {empPermissions && !(empPermissions.length > 0) && <div className="element" style={{ height: "40px", fontSize: "13px", borderBottom: "1px solid #1E485D" }}>
                                    <Icon icon="blocked-person" iconSize={10} />
                                    <div style={{ width: "60%", height: "40px", display: "flex", alignItems: "center", marginLeft: "1vw" }}>Sem permissões</div>
                                </div>}
                                
                                {/* <div onClick={() => { AcessarPaginaAnalytics("Resumo", [-1]) }} className="element" style={{ height: "40px", fontSize: "13px", borderBottom:"1px solid #1E485D", borderTop:"1px solid #1E485D" }}>
                                    <Icon icon="presentation" iconSize={10} />
                                    <div style={{ width: "60%", height: "40px", display: "flex", alignItems: "center", marginLeft: "1vw" }}>Resumo</div>
                                </div> */}
                                {/* <div onClick={() => { AcessarPaginaAnalytics("Vendas", [25]) }} className="element" style={{ height: "40px", fontSize: "13px", borderBottom:"1px solid #1E485D" }}>
                                    <Icon icon="home" iconSize={10} />
                                    <div style={{ width: "60%", height: "40px", display: "flex", alignItems: "center", marginLeft: "1vw" }}>Vendas</div>
                                </div> */}
                                {/* <div onClick={() => { AcessarPaginaAnalytics("Cessao", [25]) }} className="element" style={{ height: "40px", fontSize: "13px", borderBottom:"1px solid #1E485D" }}>
                                    <Icon icon="changes" iconSize={10} />
                                    <div style={{ width: "60%", height: "40px", display: "flex", alignItems: "center", marginLeft: "1vw" }}>Cessão</div>
                                </div> */}
                                {/* <div onClick={() => { AcessarPaginaAnalytics("Deposito", [25]) }} className="element" style={{ height: "40px", fontSize: "13px", borderBottom:"1px solid #1E485D" }}>
                                    <Icon icon="dollar" iconSize={10} />
                                    <div style={{ width: "60%", height: "40px", display: "flex", alignItems: "center", marginLeft: "1vw" }}>Depósito</div>
                                </div> */}
                                {/* <div onClick={() => { AcessarPaginaAnalytics("Planejamento", [20, 1]) }} className="element" style={{ height: "40px", fontSize: "13px", borderBottom:"1px solid #1E485D" }}>
                                    <Icon icon="gantt-chart" iconSize={10} />
                                    <div style={{ width: "60%", height: "40px", display: "flex", alignItems: "center", marginLeft: "1vw" }}>Planejamento</div>
                                </div> */}
                                {/* <div onClick={() => { AcessarPaginaAnalytics("Realizar", [20, 1]) }} className="element" style={{ height: "40px", fontSize: "13px", borderBottom:"1px solid #1E485D" }}>
                                    <Icon icon="alignment-bottom" iconSize={10} />
                                    <div style={{ width: "60%", height: "40px", display: "flex", alignItems: "center", marginLeft: "1vw" }}>Realizar</div>
                                </div> */}
                            </Collapse>
                        </div>
                    </div>
                </Component.HeaderContent>
            </Component.Container>
        </Fragment>
    );
    /* #endregion */
};

export default View;